import routingHistory from '@ackee/chris/routing-history';

export const previousLocationSelector = routingHistory.previousLocationSelectorFactory('history');
